import React from "react";
import {
    Box,
    Text,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    IconButton,
} from "@chakra-ui/react";
import { TimerGetType } from "models/timer_type";
import { formatDateRange, formatDateYYYYMMDDtoLong, formatSingleTimer } from "helpers/date";
import { MdDelete } from "react-icons/md";

type TimerRowProps = {
    timers: TimerGetType[];
    date: string;
    deleteHandler: (timer: TimerGetType) => void;
}

const TimerRow: React.FC<TimerRowProps> = ({ date, timers, deleteHandler }) => {

    return (
        <AccordionItem>
            <AccordionButton>
                <AccordionIcon />

                <Box
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    ml={4}
                    borderRadius={"md"}
                    backgroundColor={'green.300'}
                    fontSize={14}
                    fontWeight={600}
                    p={2}
                    w={6}
                    h={6}
                >
                    {timers.length}
                </Box>

                <h2>
                    <Box flex="1" textAlign="left" ml={10} fontWeight={600}>
                        Fechamento {formatDateYYYYMMDDtoLong(date)}
                    </Box>
                </h2>

                <Box
                    ml={'auto'}
                    backgroundColor={'gray.200'}
                    borderRadius={"md"}
                    p={2}
                    px={4}
                    fontSize={14}
                    fontWeight={600}
                >
                    {formatDateRange(timers)}
                </Box>
            </AccordionButton>

            <AccordionPanel pb={4}>
                <Box>
                    {timers.map(timer => (
                        <Box
                            key={timer.id}
                            p={2}
                            mb={2}
                            borderRadius={"md"}
                            backgroundColor={'gray.100'}
                            border={"1px solid #ccc"}
                            display={"flex"}
                            alignContent={"center"}
                        >
                            <Text
                                flex={1}
                                ml={2}
                                fontSize={{ sm: "14px" }}
                                borderColor="transparent"
                                display={"flex"}
                                alignItems={"center"}
                            >
                                Descrição: <b>{timer?.description || 'Sem descrição'}</b>
                            </Text>

                            <Text
                                flex={1}
                                fontSize={{ sm: "14px" }}
                                borderColor="transparent"
                                display={"flex"}
                                alignItems={"center"}
                            >
                                Projeto: <b>{timer.projeto?.descricao || 'Não informado'}</b>
                            </Text>

                            <Text
                                flex={1}
                                fontSize={{ sm: "14px" }}
                                borderColor="transparent"
                                display={"flex"}
                                alignItems={"center"}
                            >
                                Tarefa: <b>{timer?.task?.titulo || 'Não informado'}</b>
                            </Text>

                            <Box
                                flex={1}
                                display={"flex"}
                            >
                                <Text
                                    fontSize={{ sm: "14px" }}
                                    borderRadius={"md"}
                                    backgroundColor={'gray.200'}
                                    px={4}
                                    py={1}
                                >
                                    {formatSingleTimer(timer)}
                                </Text>
                            </Box>

                            <IconButton
                                colorScheme="red"
                                variant="solid"
                                borderRadius={8}
                                mr={2}
                                // isLoading={loading}
                                // isDisabled={item1.financeiroGerado}
                                size={'sm'}
                                icon={<MdDelete />}
                                onClick={() => deleteHandler(timer)}
                                aria-label={"Remover Time"}
                            />
                        </Box>
                    ))}
                </Box>
            </AccordionPanel>
        </AccordionItem>
    );
}

export default TimerRow;